import { token } from "constant/localStorage";

const API_URL = process.env.REACT_APP_API_URL;

export const uploadFile = async (file) => {
  try {
    const body = new FormData();
    body.append("files", file);
    body.append('title', JSON.stringify([file.name ?? '-']))

    const req = await fetch(`${API_URL}/file-upload`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token()}` },
      body,
    });
    const res = await req.json();

    if (!req.ok) {
      if (res.code === 401 && res.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw res.code_message;
      }
    }

    return res;
  } catch (error) {
    throw error;
  }
};
